"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[570],{

/***/ 570:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ BundleProduct)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(475);
/* harmony import */ var _accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1__);



function BundleProduct() {
  var settings = {
    customSelect: '.js-bundle-select',
    selectTrigger: '.js-bundle-trigger',
    selectOption: '.js-bundle-option',
    selectButton: '.js-bundle-select-button',
    triggerSelect: '.js-bundle-trigger-option',
    hiddenSelect: '.js-bundle-hidden-select',
    removeButton: '.js-remove-bundle-product',
    popup: '.js-bundle-popup',
    popupPrice: '.js-bundle-popup-product-price',
    popoverToggle: '.js-bundle-in-production-toggle',
    productionPopover: '.js-bundle-in-production-popover',
    overlay: '.js-overlay',
    closeButton: '.js-close-bundle',
    variantLabel: '.bundle-variant-title',
    triggerIcons: '.js-upsell-trigger-icon',
    addedMessageGroup: '.js-bundle-upsell-added',
    addedVariantPrice: '[data-bundle-upsell-added-price]',
    addedVariantTitle: '[data-bundle-upsell-added-title]',
    addedVariantImage: '[data-bundle-upsell-added-image]',
    upsellImages: '.js-upsell-img-slider',
    checkbox: '.js-add-on-check',
  }
  var config = {
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: false,
    dots: true,
    speed: 100,
    // asNavFor: settings.productThumbs,
    adaptiveHeight: window.screen.availWidth <= 768,
  }

  // var initSliders = function () {
  //   // $(settings.productThumbs).slick(thumbConfig);
  //   $(settings.upsellImages).slick(config)
  // }

  var init = function () {
    // if (!$(settings.customSelect).length) return; // need better alternative or to add check here

    initializeEventListeners()

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.selectOption + '.default').click()
    // initSliders()
  }

  var initializeEventListeners = function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.selectTrigger).on('click', togglePopup)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).on('click', closePopup)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.closeButton).on('click', closePopup)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.selectButton).on('click', addProductToBundle)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.removeButton).on('click', removeProductFromBundle)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.checkbox).on('click', handleCheckboxClick)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.variantLabel).on('click', preventDefaultLabelClickBehavior)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('keydown', closePopupOnEscapePress)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('upsell-variant-selector:added', updateAddedState)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('upsell-variant-selector:change', onVariantChange)
  }

  var preventDefaultLabelClickBehavior = function (e) {
    e.preventDefault()
  }

  var onVariantChange = function (e, { variant, product }) {
    if (!variant) return
    updateSelectButton(variant, product)
    updateBundlePrice(variant)
    updateImageSrc(variant)
    // filterImages(variant.id)
  }

  var updateBundlePrice = function (variant) {
    let price = variant.price
    let formattedPrice = formatMoney(price, '${{ amount }}')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popupPrice).text(formattedPrice)
  }

  var updateSelectButton = function (variant, product) {
    if (variant.available) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.selectButton).text(`Select ${product.title}`).attr('disabled', false)
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.selectButton).text('Out of Stock').attr('disabled', true)
    }
  }

  const addProductToBundle = function (e) {
    let upsellId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('upsell-id')
    let $triggerGroup = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-upsell=${upsellId}]`)
    let id = $triggerGroup.data('id')
    let trigger = $triggerGroup.data('trigger')
    let $activePopup = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popup + '[data-trigger="' + trigger + '"]')
    let $wrapper = $activePopup.find('[data-component="product/product-options-2"]')

    $wrapper.trigger('upsell-variant-selector:submit', { id })

    closePopup()
  }

  var updateAddedState = function (e, { variant, product }) {
    let $triggerGroup = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-upsell="upsell-${product.id}"]`)

    let $triggerIcons = $triggerGroup.find(settings.triggerIcons)
    let $addedMessageGroup = $triggerGroup.find(settings.addedMessageGroup)
    $addedMessageGroup.find(settings.addedVariantTitle).text(variant.title)
    var formattedPrice = formatMoney(variant.price, '${{ amount }}')

    $addedMessageGroup.find(settings.addedVariantPrice).text(formattedPrice)
    $addedMessageGroup.find(settings.addedVariantImage).toggleClass('tw-grid')

    $triggerIcons.toggleClass('tw-hidden')
    $addedMessageGroup.toggleClass('tw-hidden')
  }

  var removeProductFromBundle = function (e) {
    e.stopPropagation()

    let $triggerGroup = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent().parent().parent() // ehh this is gross but works rn
    let id = $triggerGroup.data('id')

    var trigger = $triggerGroup.data('trigger')
    var $activePopup = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popup + '[data-trigger="' + trigger + '"]')
    // let $wrapper = $activePopup.find('[data-snippet="product-options"]')
    let $wrapper = $activePopup.find('[data-component="product/product-options-2"]')

    $wrapper.trigger('upsell-variant-selector:remove', { id })

    let $triggerIcons = $triggerGroup.find(settings.triggerIcons)
    let $addedMessageGroup = $triggerGroup.find(settings.addedMessageGroup)

    $triggerIcons.toggleClass('tw-hidden')
    $addedMessageGroup.toggleClass('tw-hidden')
  }

  var togglePopup = function (e) {
    // if ($(this).parent().hasClass('upsell-added')) return;
    var trigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('trigger')
    var $activePopup = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popup + '[data-trigger="' + trigger + '"]')

    $activePopup.toggleClass('open')

    if ($activePopup.hasClass('open')) {
      $activePopup.css('display', 'flex')
      setTimeout(() => {
        limitUserFocus(settings.popup, settings.closeButton, settings.selectButton)
      }, 100)
    }
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popup).not($activePopup).removeClass('open')

    var overlay = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay)

    overlay.css({
      top: 0,
    })

    overlay.toggleClass(['active', 'cart-overlay', 'popup-overlay'])

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popup).hasClass('open')) {
      addNoScroll()
    } else {
      removeNoScroll()
    }
  }

  var closePopup = function (e) {
    removeNoScroll()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popup).removeClass('open')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popup).css('display', 'none')

    /*setTimeout(() => {
        $(settings.popup).css('visibility', 'hidden')
      }, 500)*/

    var overlay = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay)

    overlay.css({
      top: 0,
    })

    overlay.removeClass(['active', 'cart-overlay', 'popup-overlay'])
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.selectTrigger).focus()
  }

  var closePopupOnEscapePress = function (e) {
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popup).hasClass('open') && e.key === 'Escape') {
      closePopup()
    }
  }

  var updateImageSrc = function (variant) {
    const image = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.upsellImages).find('img')
    image.prop('src', variant.featured_image.src)
    image.prop('srcset', variant.featured_image.src)
  }

  // var filterImages = function (id) {
  //   var $slider = $(settings.upsellImages)
  //   $slider.slick('slickUnfilter')
  //   $slider.slick('slickFilter', function (index, slide) {
  //     var $slide = $(slide).find('img')
  //     var slideId = $slide.data('variant-id')
  //     // return true;
  //     return slideId == id
  //   })

  //   $slider.slick('slickGoTo', 0, true)

  //   if ($slider.find('img').length === 0) {
  //     $slider.slick('slickUnfilter')
  //   }
  // }

  var handleCheckboxClick = function (e) {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let checkboxName = $this.attr('for')
    let $checkbox = $this.siblings(`[name="${checkboxName}"]`)
    if ($checkbox.prop('checked') == true) {
      $checkbox.prop('checked', false)
    } else {
      $checkbox.prop('checked', true)
    }
  }

  init()
}


/***/ })

}]);